import React from 'react';
import { Card, Typography } from 'antd';

const { Title } = Typography;

const ReportGeneratorTest = () => {
  return (
    <div style={{ padding: 24 }}>
      <Card>
        <Title level={2}>Installation Report Generator - Test</Title>
        <p>If you can see this, the route is working!</p>
      </Card>
    </div>
  );
};

export default ReportGeneratorTest;
